const styles = (theme) => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
    },
    field: {
        flex: 1,
    },
    btnCarregar: {
        borderRadius: '20px',
        background: 'transparent',
        textTransform: 'none',
        color: '#DE8C4D',
        borderColor: '#DE8C4D',
        padding: '4px 10px',
        marginRight: '10px',
    },
    input: {
        marginLeft: theme.spacing(1),
        flex: 1,
    },
    error: {
        fontSize: '.9em',
    },
    icon: {
        fontSize: '18px',
        marginRight: '10px',
    },
    documentLabel: {
        marginBottom: '.5em',
        fontSize: '.9em',
    },
});

export default styles;
